import { render, staticRenderFns } from "./delegated-inquiry.vue?vue&type=template&id=56212558&scoped=true&"
import script from "./delegated-inquiry.vue?vue&type=script&lang=js&"
export * from "./delegated-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./delegated-inquiry.vue?vue&type=style&index=0&id=56212558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56212558",
  null
  
)

export default component.exports